import request from "@/lib/util/request";
import {AccessToken} from "@/lib/type/login-register.type";
import {AddressInterface, UpdateAddressParams} from "@/lib/type/address.type";

// 获取收获地址
export const requestAddress = (params?: AccessToken) => request<AddressInterface[]>({
    endpoint: "/api/tiny-shop/v1/member/address/index",
    params: params,
    method: "GET",
    cache: "no-cache"
});

// 更新收货地址
export const requestUpdateAddress = (id: string, data: UpdateAddressParams) => request<AddressInterface>({
    endpoint: "/api/tiny-shop/v1/member/address/update",
    method: "PUT",
    body: data,
    params: {id}
});

// 删除收货地址
export const requestDeleteAddress = (id: string) => request({
    endpoint: "/api/tiny-shop/v1/member/address/delete",
    method: "DELETE",
    params: {id}
});

// 获取省市区
export const requestGetAreaList = (pid?: string) => request<any[]>({
    endpoint: "/api/tiny-shop/v1/common/provinces/index",
    params: {
        pid
    }
});

// 创建收货地址
export const requestAddAddress = (data: UpdateAddressParams) => request({
    endpoint: "/api/tiny-shop/v1/member/address/create",
    method: "POST",
    body:data
});
